import { IFetchListRequestPayload } from '@interfaces/common';
import {
  ICreateNewSupplementResponse,
  IDietarySupplementDetails,
  IDietarySupplementSearchResult,
  ISubmitSupplementNeedsInfoFormPayload,
  ISupplementResponseDetails,
  IUserEnteredSupplement,
  IUserEnteredSupplementData,
} from '@interfaces/supplements';

import { apiUrls } from './urls';
import { get, post, put } from './utils';

export const createNewSupplement = (payload: IUserEnteredSupplementData) =>
  post<ICreateNewSupplementResponse>(apiUrls.userEnteredSupplements.create, payload);

export const editUserEnteredSupplement = (payload: IUserEnteredSupplement) =>
  put(apiUrls.userEnteredSupplements.update, payload);

export const getSupplementResponseDetails = (supplementId: number) =>
  get<ISupplementResponseDetails>(`${apiUrls.inquiries.responseDetails}/${supplementId}`);

export const markSupplementResponseAsViewed = (supplementId: number) =>
  post(`${apiUrls.inquiries.supplementViewed}/${supplementId}`);

export const submitSupplementNeedsInfoForm = (payload: ISubmitSupplementNeedsInfoFormPayload) =>
  post(apiUrls.userEnteredSupplements.addNote, payload);

export const searchSupplements = (payload: IFetchListRequestPayload) =>
  post<IDietarySupplementSearchResult>(apiUrls.supplements.search, payload);

export const getSupplementDetails = (id: number) =>
  get<IDietarySupplementDetails>(`${apiUrls.supplements.details}/${id}`);

export const getUserEnteredSupplementDetails = (id: number) =>
  get<IUserEnteredSupplement>(`${apiUrls.userEnteredSupplements.details}/${id}`);
